import { render, staticRenderFns } from "./VennDiagramElement.vue?vue&type=template&id=5885762a&"
import script from "./VennDiagramElement.vue?vue&type=script&lang=js&"
export * from "./VennDiagramElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VennDiagramElement.vue"
export default component.exports